// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxWithLabel_container__2MABq","checkbox":"CheckboxWithLabel_checkbox__yxWAA","text":"CheckboxWithLabel_text__3hHk2"};